import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconMessengerBranded$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconMessengerBranded extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '49a7275bd220dfdcc76f0d42f0b372f1b71279d1', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '0ac1ec96d4adb49424ba86c8810f75f91b4946eb', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '5ac006e2bf891761b1dab251422917c535637098', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 19.244c4.86 0 8.8-3.815 8.8-8.522S15.86 2.2 11 2.2s-8.8 3.815-8.8 8.522c0 2.56 1.165 4.856 3.01 6.418v1.725a.927.927 0 0 0 1.3.855l1.913-.847c.815.241 1.68.371 2.577.371", fill: "url(#a)" }), h("path", { key: 'bd327b23d71746e3138967eeb9914d1110550ef1', d: "M8.893 8.91 6.34 12.4c-.274.375.218.824.593.542l2.179-1.64a.64.64 0 0 1 .757-.005l1.938 1.414a.85.85 0 0 0 1.173-.173l2.677-3.613c.277-.375-.219-.828-.594-.543l-2.304 1.754a.64.64 0 0 1-.76.008l-1.931-1.41a.85.85 0 0 0-1.176.177", fill: "#fff" }), h("defs", { key: '851bf3be7d130d716bec3aa9b546171f05e325a0' }, h("linearGradient", { key: 'f96f41926964729328e8d5f085808c30ba6a088c', id: "a", x1: "11", y1: "2.2", x2: "8.176", y2: "19.704", gradientUnits: "userSpaceOnUse" }, h("stop", { key: 'e231ebb7e6fe98e162e38f9530677a23db3d0bdf', "stop-color": "#00B1FF" }), h("stop", { key: '174a4aca08a5315c85c840a981c1ed1099dbe461', offset: "1", "stop-color": "#006BFF" }))))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-messenger-branded", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-messenger-branded"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-messenger-branded":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconMessengerBranded$1);
            }
            break;
    } });
}

const CosmosIconMessengerBranded = CosmosIconMessengerBranded$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconMessengerBranded, defineCustomElement };
